import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    margin: '0 auto',
    padding: theme.spacing(2),
    width: '100%',
    maxWidth: 1440,
    boxSizing: 'border-box',
    [theme.breakpoints.up('sm')]: {
      width: '90%',
    },
    [theme.breakpoints.up('md')]: {
      width: '75%',
    },
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60vh',
  },
  mainTitle: {
    fontSize: '20px',
    fontWeight: 700,
    fontFamily: 'Montserrat',
    color: '#5BC2D5',
  },
  summaryContainer: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: theme.shape.borderRadius,
    padding: '20px',
    boxShadow: theme.shadows[2],
    gap: '20px',
  },
  itemBox: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: theme.shape.borderRadius,
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  itemLeft: {
    width: '100%',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      width: '60%',
    },
  },
  itemRight: {
    width: '100%',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      width: '40%',
    },
  },
  title: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: '14px',
    color: theme.palette.text.primary,
    minHeight: '17px',
    verticalAlign: 'middle',
  },
  discountText: {
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: '14px',
    textDecoration: 'line-through',
    color: theme.palette.text.primary,
    height: '17px',
    verticalAlign: 'middle',
  },
  priceText: {
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: '14px',
    color: theme.palette.text.primary,
    height: '17px',
    verticalAlign: 'middle',
  },
  warningText: {
    fontSize: '16px',
    fontWeight: 700,
    color: theme.palette.error.main,
    textAlign: 'center',
    fontFamily: 'Montserrat',
  },
  finalTotalBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  totalLabel: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '100%',
    color: theme.palette.text.primary,
  },
  totalValue: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: '25px',
    lineHeight: '100%',
    color: theme.palette.primary.main,
  },
  paymentButtonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  warningTextContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.error.light,
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.error.main}`,
    color: theme.palette.common.white,
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '100%',
  },
  paymentButton: {
    padding: theme.spacing(1.5),
    fontWeight: 600,
    textTransform: 'none',
    fontSize: '1rem',
  },
  backButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0px',
  },
  backButtonIcon: {
    padding: '0px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  backIcon: {
    color: theme.palette.error.main,
    fontSize: '30px',
    fontWeight: 700,
  },
  pageTitle: {
    fontSize: '20px',
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
}));
